import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgInjuryArmsling = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8.14575 4.8125C8.14575 5.39266 8.37622 5.94906 8.78646 6.3593C9.19669 6.76953 9.75309 7 10.3333 7C10.9134 7 11.4698 6.76953 11.88 6.3593C12.2903 5.94906 12.5208 5.39266 12.5208 4.8125C12.5208 4.23234 12.2903 3.67594 11.88 3.2657C11.4698 2.85547 10.9134 2.625 10.3333 2.625C9.75309 2.625 9.19669 2.85547 8.78646 3.2657C8.37622 3.67594 8.14575 4.23234 8.14575 4.8125V4.8125Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.3333 16.375V20.125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.83325 16.375V20.125C7.83325 20.4565 7.96495 20.7745 8.19937 21.0089C8.43379 21.2433 8.75173 21.375 9.08325 21.375C9.41477 21.375 9.73272 21.2433 9.96714 21.0089C10.2016 20.7745 10.3333 20.4565 10.3333 20.125C10.3333 20.4565 10.4649 20.7745 10.6994 21.0089C10.9338 21.2433 11.2517 21.375 11.5833 21.375C11.9148 21.375 12.2327 21.2433 12.4671 21.0089C12.7016 20.7745 12.8333 20.4565 12.8333 20.125V12.2083C13.2829 12.9123 13.9029 13.4915 14.636 13.892C15.369 14.2926 16.1912 14.5018 17.0266 14.5H17.2083C17.5398 14.5 17.8577 14.3683 18.0921 14.1339C18.3266 13.8995 18.4583 13.5815 18.4583 13.25C18.4583 12.9185 18.3266 12.6005 18.0921 12.3661C17.8577 12.1317 17.5398 12 17.2083 12H17.0266C16.5621 12.0001 16.1069 11.8707 15.7118 11.6266C15.3168 11.3824 14.9975 11.033 14.7899 10.6175L14.6424 10.3225C14.2377 9.51312 13.554 8.87736 12.7174 8.5325"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.87409 8.44916C7.13286 8.70165 6.48927 9.17984 6.03359 9.81665C5.57791 10.4535 5.33302 11.2169 5.33325 12V12.625C5.33325 12.9565 5.46495 13.2745 5.69937 13.5089C5.93379 13.7433 6.25173 13.875 6.58325 13.875H7.83325"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.3333 8.25L7.83325 13.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.94409 11.375H9.70825C10.0398 11.375 10.3577 11.5067 10.5921 11.7411C10.8266 11.9755 10.9583 12.2935 10.9583 12.625C10.9583 12.9565 10.8266 13.2745 10.5921 13.5089C10.3577 13.7433 10.0398 13.875 9.70825 13.875H7.83325"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgInjuryArmsling.displayName = 'SvgInjuryArmsling';
export default SvgInjuryArmsling;
